enum UserTypes {
    ANONYMOUS = 'anonymous',
    NEDOUSER = 'nedouser',
    BACKOFFICE = 'backoffice',
    EMPLOYER = 'employer',
    APPLICANT = 'applicant',
}

export default UserTypes;
